export enum ArchiveReasonEnum {
  User = 'User',
  Expire = 'Expire',
  Commit = 'Commit'
}
